export const timelineData = [
  {
    year: "2023",
    description:
      "The Fifth Principal Dr.R.Marimuthu started three courses Bachelor’s Degrees in Hotel Management & Catering Science, Nutrition & Dietetics and Artificial Intelligence & Data Science.",
    imageUrl: "image1.jpg",
  },
  {
    year: "2017-2022",
    description:
      "The Fourth Principal, Dr.S.Perumal introduced the Bachelor’s Degrees of Business Management, Mathematics & Chemistry, PG Courses in Commerce and Biotechnology.",
    imageUrl: "image2.jpg",
  },
  {
    year: "2011-2016",
    description:
      "Post Graduate courses such as English, Bioinformatics, Computer Science & Tamil, Master of Philosophy in  Mathematics, Computer Science, & Information Technology, Doctorate Programme in Microbiology were introduced during the period of Third Principal (2010-2016) Dr.V.Umayorubhagan.",

    imageUrl: "image3.jpg",
  },
  {
    year: "2005-2010",
    description:
      "The Second Principal (2004-2010) Dr.B.Krishnan Introduced Bachelor’s Degrees of Biotechnology, Microbiology, Bioinformatics, and Bachelor of Commerce & Commerce with Computer Applications.",
    imageUrl: "image4.jpg",
  },
  {
    year: "2001-2004",
    description:
      "Our institution was Established in 2001, by the  Philanthropist Janab Dr. A. P. Majeed Khan. Dr.M.L.Narayanan was the First Principal (2001-2004) who introduced three Bachelor’s Degree Computer Science, Information Technology & Computer Application(BCA).",
    imageUrl: "image5.jpg",
  },
];
